import React from 'react';
import { Linking, Pressable, StyleSheet, View } from 'react-native';
import useTranslation from '../../hooks/translation-hook';
import NavigationElements from '../../models/NavigationElements';
import MyAccountPageWrapper from './MyAccountPageWrapper';
import Label, { LabelType } from '../common/Label';
import useCustomTheme from '../../hooks/theme-hook';

const Help = () => {
  const t = useTranslation();
  const theme = useCustomTheme();

  const cardBackground = theme.background?.modal ?? theme.background?.primary;
  const titleColor = theme.text?.darkTurquoiseTwo ?? theme.primary;
  const bodyColor = theme.text?.primary ?? 'white';
  const errorColor = theme.isDark ? theme.text?.error : theme.colorErrorPrimary;
  const linkColor = theme.text?.sea ?? theme.primary;
  const fullTextLines = 20;

  const renderSection = (titleKey: string, bodyKey: string) => (
    <View style={[styles.card, { backgroundColor: cardBackground }]}>
      <Label variant={LabelType.titleSmall} style={[styles.cardTitle, { color: titleColor }]} numberOfLines={fullTextLines}>
        {t(titleKey)}
      </Label>
      <Label style={[styles.cardBody, { color: bodyColor }]} numberOfLines={fullTextLines}>
        {t(bodyKey)}
      </Label>
    </View>
  );

  return (
    <MyAccountPageWrapper navigationTitle={t('my_profile')} title={t('help_support')} navigationAction={NavigationElements.menu}>
      <View style={styles.container}>
        <Label style={[styles.intro, { color: bodyColor }]} numberOfLines={fullTextLines}>
          {t('id-verification-help-intro')}
        </Label>

        {renderSection('id-verification-help-why-title', 'id-verification-help-why-body')}
        {renderSection('id-verification-help-adult-title', 'id-verification-help-adult-body')}
        {renderSection('id-verification-help-minor-title', 'id-verification-help-minor-body')}
        {renderSection('id-verification-help-status-title', 'id-verification-help-status-body')}
        {renderSection('id-verification-help-resubmission-title', 'id-verification-help-resubmission-body')}

        <Pressable
          accessibilityRole="link"
          onPress={() => {
            Linking.openURL(t('id-verification-lanla-website-support-link')).catch(() => undefined);
          }}
          style={styles.articleLink}
        >
          <Label style={[styles.articleLinkText, { color: linkColor }]} numberOfLines={1}>
            {t('learn-more')}
          </Label>
        </Pressable>

        <View style={styles.notice}>
          <Label style={[styles.noticeText, { color: errorColor }]} numberOfLines={fullTextLines}>
            {t('id-verification-help-retention')}
          </Label>
        </View>
      </View>
    </MyAccountPageWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    paddingBottom: 32,
  },
  intro: {
    fontSize: 15,
    lineHeight: 20,
    marginBottom: 18,
  },
  card: {
    borderRadius: 7,
    marginBottom: 12,
    paddingHorizontal: 14,
    paddingVertical: 14,
  },
  cardTitle: {
    fontSize: 16,
    lineHeight: 20,
    marginBottom: 8,
    textTransform: 'uppercase',
  },
  cardBody: {
    fontSize: 14,
    lineHeight: 19,
  },
  articleLink: {
    alignSelf: 'flex-start',
    marginBottom: 16,
    marginTop: 2,
    paddingVertical: 4,
  },
  articleLinkText: {
    fontSize: 16,
    lineHeight: 19,
  },
  notice: {
    marginTop: 6,
    paddingBottom: 20,
  },
  noticeText: {
    fontSize: 14,
    lineHeight: 19,
    fontWeight: '700',
  },
});

export default Help;
